<template>
  <div>
    <ts-page-title
      :title="$t('payrollTemplate.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('payrollTemplate.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-card>
      <ts-card-wrapper class="d-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click.prevent="addNew">{{
          $t('addNew')
        }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <ts-input
            search
            v-model="search"
            :placeholder="$t('payslipTemplate.search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row 
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="created_by">
          {{
            row.created_by
              ? row.created_by.employee
                ? row.created_by.employee.employee_name_en
                : row.created_by.user_name
              : ''
          }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            class="text-warning ts-mr-2"
            @click.prevent="designTemlate(row)"
            v-tooltip="$t('payrollTemplate.designTemplate')"
          >
            <i class="fas fa-file-signature"></i>
          </a>
          <a
            href=""
            class="text-blue ts-mr-2"
            @click="templateRowValue = row"
            v-tooltip="$t('payrollTemplate.uploadTemplate')"
          >
            <label for="uploadTemplate" class="text-primary ts-cursor-pointer">
              <i class="fas fa-file-upload"></i>
            </label>
          </a>
          <a
            href="#"
            class="text-primary ts-mr-1"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip
            confirm
            :title="$t('areYouSure')"
            @on-ok="onDelete(row)"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
            placement="left"
            :transfer="true"
          >
            <a
              class="ml-2 text-danger"
              v-tooltip="$t('delete')"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
        <input
          type="file"
          id="uploadTemplate"
          ref="uploadTemplate"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="uploadTemplate"
          style="display:none"
        />
      </div>
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('payrollTemplate.pageTitle')"
        centered
        :zIndex="1020"
        :footer="null"
        width="80%"
      >
        <form-action @close="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import FormAction from './form.vue'
import { mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim, debounce } from 'lodash'

export default {
  name: 'payroll-template',
  components: {
    FormAction
  },
  data () {
    return {
      loading: false,
      width: 'width: 300px',
      templateRowValue: [],
      file: '',
      errors: new Errors(),
      showForm: false
    }
  },
  computed: {
    ...mapState('payroll/payrollTemplate', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.payroll.payrollTemplate.search
      },
      set (newValue) {
        this.$store.commit('payroll/payrollTemplate/SET_SEARCH', newValue)
        this.$store.commit('payroll/payrollTemplate/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('payrollTemplate.templateName'),
          key: 'template_name',
          sortable: true,
          minWidth: 250
        },
        {
          title: this.$t('payrollTemplate.templateType'),
          key: 'template_type',
          align: 'center',
          sortable: true,
          minWidth: 100
        },
        {
          title: this.$t('payslipTemplate.payrollCycleNumber'),
          key: 'payroll_cycle_number_text',
          align: 'center',
          sortable: true,
          minWidth: 100
        },
        {
          title: this.$t('payslipTemplate.createdBy'),
          slot: 'created_by',
          sortable: true,
          minWidth: 100
        },
        {
          title: this.$t('payslipTemplate.createdDate'),
          key: 'created_date',
          sortable: true,
          align: 'right',
          minWidth: 100
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  methods: {
    addNew () {
      this.showForm = true
      this.$store.commit('payroll/payrollTemplate/SET_EDIT_DATA', {})
      this.$store.commit('payroll/payrollTemplate/SET_VARIABLE', [])
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('payroll/payrollTemplate/fetch', { ...attributes })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit (record) {
      this.$store.commit('payroll/payrollTemplate/SET_EDIT_DATA', record)
      this.showForm = true
      this.$store.commit('payroll/payrollTemplate/SET_VARIABLE', [])
    },
    clearEdit () {
      this.showForm = false
      this.$store.commit('payroll/payrollTemplate/SET_EDIT_DATA', {})
      this.$store.commit('payroll/payrollTemplate/SET_VARIABLE', [])
    },
    designTemlate (record) {
      this.loading = true
      this.$store
        .dispatch('payroll/payrollTemplate/design', {
          id: record.template_id,
          override: record.is_override
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(errorData => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(errorData))
          )
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async uploadTemplate () {
      this.file = this.$refs.uploadTemplate.files[0]
        ? this.$refs.uploadTemplate.files[0]
        : null
      if (this.file) {
        this.loading = true

        let formData = new FormData()
        formData.append('template_file', this.file)

        this.$store
          .dispatch('payroll/payrollTemplate/uploadTemplate', {
            id: this.templateRowValue.template_id,
            data: formData
          })
          .then(response => {
            this.notice({
              type: 'success',
              text: response.message
            })
            this.$refs.uploadTemplate.value = ''
            this.loading = false
            this.templateRowValue = []
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(
              this.errors.has('template_file')
                ? this.errors.first('template_file')
                : error.message
            )
            this.$refs.uploadTemplate.value = ''
            this.loading = false
            this.templateRowValue = []
          })
      }
    },
    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('payroll/payrollTemplate/destroy', record.template_id)
          .then(response => {
            this.fetchData()
            this.notice({ type: 'success', text: response.message })
            record._deleting = false
          })
          .catch(error => {
            this.notice({ type: 'error', text: error.message })
            record._deleting = false
          })
      }
    },
    onDelete (record) {
      record._deleting = true
      this.$store
        .dispatch('payroll/payrollTemplate/destroy', record.template_id)
        .then(response => {
          this.fetchData()
          record._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          record._deleting = false
        })
    },

    notice (not) {
      this.$Notice[not.type]({
        title: 'REPORT CUSTOMIZATION',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('payroll/payrollTemplate/RESET_STATE')
    next()
  }
}
</script>
